<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/m7QjFn/tc-custom/9781504084765.jpg?1689788351265" alt="This image is the cover for the book Rebel King"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rebel King
      </h1>
      <p class="bookDescription body article font2">
        <b>This unauthorized biography of King Charles III follows his twenty-year struggle with his public image in the wake of Diana’s death.</b><br/><br/> Numerous challenges face King Charles III as he succeeds his mother to the throne of the United Kingdom. While Elizabeth II had a long history of uniting her people, Charles has always been less popular and often divisive. Following Princess Diana’s death, his approval rating plummeted to four percent—the lowest for any royal in recent times. Charles’s public support improved following his marriage to Camilla, but how was he able to turn things around? And what sort of monarch will he be?<br/><br/> In <i>Rebel King</i>, investigative journalist and historian Tom Bower chronicles two dramatic decades of King Charles’s life. He examines Charles’s battle for rehabilitation after Diana’s death and his refusal to obey the public’s expectations of a future king. This book gathers testimonies from more than 120 individuals, many of whom served the royals for long periods and with great distinction. The result reveals dramatic secrets and offers an unrivalled, intimate portrait of the man, the heir, and the making of a king.<br/><br/> Previously published as <i>Rebel Prince</i>.<br/><br/><b>Praise for <i>Rebel King</i></b><br/><br/> “A devastating book by Britain’s top investigative author.” —<i>Daily Mail</i><br/><br/> “Explosive . . . delves inside the bizarre, ultra luxury world of Prince Charles.” —<i>The Sun</i><br/><br/> “There is more than enough carping, cosseting and cattiness here to satisfy any appetite for royal intrigue.” —<i>The Sunday Times</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Bower
      </h2>
      
      <p class="authorDescription body article">Tom Bower (b. 1946) is a British writer and investigative journalist. A former reporter for BBC&rsquo;s <I>Panorama</I>, his books include unauthorized biographies of Tiny Rowland, Robert Maxwell, Mohamed Al-Fayed, Geoffrey Robinson, Gordon Brown, and Richard Branson. He won the 2003 William Hill Sports Book of the Year Award for <I>Broken Dreams</I>, an investigation into corruption in English football.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42d5a75a